import { render, staticRenderFns } from "./Intercom.vue?vue&type=template&id=4f823ac0&scoped=true"
import script from "./Intercom.vue?vue&type=script&lang=js"
export * from "./Intercom.vue?vue&type=script&lang=js"
import style0 from "./Intercom.vue?vue&type=style&index=0&id=4f823ac0&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f823ac0",
  null
  
)

export default component.exports